import EN from './EN';

export default {
  quickActions: '빠른 작업',
  ...EN,
  servers: {
    name: '서버',
    auto: '자동',
    vietnam: '베트남',
    singapore: '싱가포르',
    main: '주 서버',
    reserve: '보조 서버'
  },
  recommend: '추천',
  quantityInvalid: '잘못된 수량',
  returnToHome: '홈 화면으로 돌아가기',
  forever: '영원히',
  expired: '만료됨',
  barcodeTable: '상품 바코드 테이블',
  price: '가격',
  autoGen: '자동 생성',
  check: '확인',
  signature: '서명',
  renew: '갱신',
  updatedAt: '업데이트 시간',
  saveDraft: '초안 저장',
  buy: '구매',
  birthday: '생일',
  barcodeNotFound: '이 바코드를 찾을 수 없습니다!',
  saved: '저장됨',
  reality: '현실',
  difference: '차이',
  hide: '숨기기',
  editComponent: '외관 사용자 정의',
  amount: '수량',
  search: '검색',
  simple: '간단하다',
  more: '더',
  saveImage: '이미지 저장',
  next: '계속',
  share: '공유하다',
  inventoryDelivery: '재고 배송',
  type: '유형',
  transactionHistory: '거래내역',
  blanceAndDebt: '잔고/부채',
  limitWarning: '반복된 환불로 인해 계정이 제한되었습니다. 3회를 초과하면 계정이 영구적으로 잠기며 데이터를 복구할 수 없습니다. 감사합니다!',
  upgradePro: '업그레이드',
  iapSupport: '',
  emptyData: '아직 데이터 없음',
  seemore: '더 보기',
  version: '버전',
  financialIn30days: '지난 30일 동안의 재무',
  financialInMonth: '이번 달 재정',
  orFastLoginWith: '또는 빠른 로그인',
  fontSize: '글꼴 크기',
  changeFontSizeWarning: '글꼴 크기가 변경되었습니다. 앱이 안정적으로 작동하려면 앱을 종료하고 다시 시작해야 합니다.',
  fontSizeList: ['매우 작음', '소형', '중형', '대형', '매우 크다', '매우 매우 큼'],
  contact: '연락처',
  cause: '이유',
  default: '기본값',
  manager: '관리',
  paymentMethod: '결제 수단',
  paymentMethodList: ['현금', '계좌이체', '직불'],
  printerVideoDemo: '연결 안내 동영상',
  supportWarning: '지원이 필요한 경우 개발팀의 Facebook 채널에 문의하십시오. 응원해주셔서 감사합니다!',
  offlineWarning:
    '오프라인을 사용하고 있습니다. 온라인에서 사용할 계정을 등록해야 데이터 손실을 방지하고 데스크톱 버전을 사용할 수 있을 뿐만 아니라 다른 많은 기능을 사용할 수 있습니다.',
  updating: '업데이트 중',
  remain: '나머지',
  choiceProductTypeWarning: '제품 카테고리를 선택하세요',
  editProduct: '상품 편집',
  onlyOnlineSupport: '이 기능은 온라인만 지원합니다. 이 기능을 사용하려면 계정에 로그인하세요!',
  createBy: '작성자',
  userName: '사용자 이름',
  fullName: '이름과 성',
  webVersion: '웹 버전',
  syncingProgress: '동기화가 진행 중입니다. 1~15분 정도 기다리십시오. 프로세스가 완료되면 이메일을 보내드립니다',
  bulkDelete: '대량 삭제',
  sync: '동기화',
  offline: '오프라인',
  offlineNotSupport: '오프라인 지원되지 않음',
  warning: '경고',
  back: '뒤',
  yes: '예',
  no: '아니요',
  refresh: '새로고침',
  tryAgain: '다시 시도',
  home: '집',
  language: '언어',
  quantity: '금액',
  theme: '외모',
  dark: '어두운',
  light: '빛',
  total: '총계',
  paid: '지불',
  totalReminder: '총 남은 시간',
  totalMoney: '총 금액',
  payed: '유료',
  totalDebit: '총 미결제 금액',
  oldPrint: '청구서 인쇄(간단)',
  totalOldDebit: '오래된 부채',
  totalOldReminder: '이전 잔액',
  debit: '부채',
  remainder: '남은',
  status: '상태',
  create: '새로 추가',
  add: '새로 추가',
  save: '저장',
  print: '인쇄',
  export: '송장 내보내기',
  copy: '복사',
  edit: '편집',
  delete: '삭제',
  update: '업데이트',
  updateStatus: '상태 업데이트',
  day: '날짜',
  from: '보낸사람',
  to: '받는 사람',
  fromDate: '시작일',
  toDate: '종료일',
  choiceImage: '이미지 선택',
  exist: '이미 존재',
  invalidParams: '충분한 데이터를 입력하세요',
  success: '성공',
  fail: '실패',
  all: '모두',
  complete: '완료',
  pending: '대기 중',
  canceled: '취소됨',
  cancel: '취소',
  ok: '동의',
  or: '또는',
  choice: '선택',
  confirm: '확인',
  confirmExitApp: '앱을 종료하시겠습니까?',
  time: '시간',
  notFound: '데이터를 찾을 수 없습니다. 다시 시도하십시오!',
  createdAt: '만든 날짜',
  none: '없음',
  detail: '세부 정보',
  filter: '필터',
  filterByTim: '시간별 필터링',
  note: '메모',
  trial: '사용해 보기',
  option: '옵션',
  notify: '공지',
  understand: '지우기',
  exportToExcel: '엑셀로 내보내기',
  sorryText: '',
  multiHidden: '일괄 숨기기',
  multiActive: '배치 트리거',
  hiddenList: '히든 리스트',
  showList: '활성화 목록',
  importDataFromExcel: '엑셀에서 가져오기',
  describe: '제품 설명',
  addImage: '이미지 추가',
  limitUpload: '한 번에 최대 5장의 사진만 게시할 수 있습니다',
  limitFeature: {
    intro: '무료로 체험하실 수 있습니다. 그리고 정말 필요할 때 지불하세요',
    free: '무료 버전',
    pro: '프리미엄(유료) 버전',
    title: '이 기능을 사용하려면 프리미엄 버전을 구매해야 합니다',
    package: '프리미엄 패키지',
    packageOther: '기타 서비스 패키지',
    features: [
      '광고 없음',
      '무제한 상품 생성(상품 100개로 제한되는 무료 버전)',
      '무제한 주문',
      '송장 인쇄 또는 발행 무제한',
      '상품 바코드 인쇄 기능(웹 버전)',
      '고객을 위한 포인트 적립 기능',
      '주문 복사 기능',
      '가맹점 납부할증료 기능',
      '반품 기능',
      '오래된 물건 숨기기 기능',
      '상품 분류 기능(예: 청바지 상품의 사이즈 분류는 M, L, XL입니다)',
      '데이터를 엑셀 파일로 가져오고 내보내는 기능',
      '영수증 및 결제 추가 기능',
      '고객에게 구채권 전표를 추가하는 기능',
      '배송메모 작성 기능',
      'QR코드를 생성하여 주문금액을 직접 결제하는 기능',
      '드래프트 메뉴 기능, 네트워크 연결이 없을 때 드래프트 메뉴 생성',
      '웹 버전(데스크톱) 무제한 사용'
    ],
    freeFeatures: [
      '광고를 표시합니까',
      '상품 100개 한정',
      '오래된 물건을 숨기는 기능 제한',
      '가맹점 추가요금 제한 기능',
      '한도반환 기능',
      '제한된 바코드 인쇄 기능',
      '한정 고객 포인트 적립 기능',
      '제한된 상품 분류 기능',
      '인보이스 인쇄 또는 내보내기 제한',
      '엑셀로 내보내기 제한',
      '영수증 및 결제 추가 기능 제한',
      '채무기록 추가 기능 제한',
      'Excel 파일에서 상품과 고객을 가져오는 기능을 제한합니다',
      '배달 메모 작성 기능 제한',
      '초안 메뉴 기능 제한',
      '한정결제 QR코드 생성 기능',
      '웹 버전 3개월 무료'
    ]
  },
  syncDetail: {
    text1: '기기에서 계정으로 데이터를 동기화합니다. 이 프로세스는 한 번만 수행해야 합니다. ',
    text2: '각 계정은 한 번만 성공적으로 동기화할 수 있습니다',
    text3: '이 함수는 아직 테스트 중입니다. 오류가 발생하면 가능한 한 빨리 개발자에게 도움을 요청하십시오. ',
    start: '동기화 시작',
    feedback: '개발자에게 피드백',
    sendErrorData: '오류 데이터 보내기',
    sure: '이 계정과 데이터를 동기화하시겠습니까? ',
    syncedError: '이 계정이 시계에 있습니다.',
    syncedAlert: '이 계정은 오프라인 데이터가 아닙니다. 지금 동기화하시겠습니까? '
  },
  account: {
    ...EN.account,
    systemSmartSubtitle: '스마트 판매 관리 시스템',
    switch: '계정 전환',
    switchConfirm: '%s 계정으로 전환하시겠습니까?',
    switchDeleteConfirm: '%s 계정의 로그인 세션을 삭제하시겠습니까?',
    requiredInfo: '필수 정보를 모두 입력하세요',
    enterCodeRequired: '확인 코드를 입력하세요',
    enterPasswordRequired: '두 비밀번호를 모두 입력하세요',
    passwordNotMatch: '두 비밀번호가 일치하지 않습니다',
    loginSubtitle: '다시 오신 것을 환영합니다!',
    registerSubtitle: '오늘 가입하고 탐색해보세요!',
    noAccountYet: '아직 계정이 없으신가요?',
    alreadyHaveAccount: '이미 계정이 있으신가요?',
    forgotPasswordStepEmail: '비밀번호 복구를 시작하려면 이메일을 입력하세요.',
    forgotPasswordStepCode: '이메일로 전송된 6자리 인증 코드를 입력하세요.',
    forgotPasswordStepPassword: '계정을 보호하기 위해 안전한 비밀번호를 사용하세요.',
    backToLogin: '로그인으로 돌아가기',
    loginWithoutEmail: '이메일 없이 로그인',
    loginWithoutEmailError: '기기 코드를 생성할 수 없습니다. 안내를 위해 지원팀에 문의하세요!',
    offlineDeprecated:
      '2025년 3월 13일부터 이 애플리케이션은 오프라인 기능을 더 이상 지원하지 않습니다.\n오프라인을 무료로 사용하려면 aSeller Offline 앱(주황색 아이콘 앱)을 다운로드하세요.\n감사합니다!',
    sendCodeSuccess: '코드가 포함된 이메일을 보냈습니다. 이메일에서 확인 코드를 확인하세요',
    errorCode: '잘못된 확인 코드',
    codeExpired: '인증 코드가 만료되었습니다.',
    forgotPassword: '비밀번호 찾기',
    enterEmail: '이메일 입력',
    enterCode: '확인 코드 입력',
    sendCode: '확인 코드 보내기',
    renewPassword: '비밀번호 갱신',
    submitCode: '확인',
    changePassword: '비밀번호 변경',
    newPassword: '새 비밀번호',
    refreshPassword: '새 비밀번호 재설정',
    password: '비밀번호',
    repassword: '비밀번호 다시 입력',
    register: '등록',
    inputSoShort: '사용자 이름 또는 비밀번호가 너무 짧습니다',
    repassWrong: '재입력한 비밀번호가 올바르지 않습니다',
    emailExist: '이메일이 이미 존재합니다',
    logout: '로그아웃',
    login: '로그인',
    offlineMode: '오프라인 사용',
    offlineModeWarning: '오프라인에서 사용하면 데이터가 기기에 저장됩니다. 데이터 손실 없이 다른 기기로 전환하기 전에 로그인해야 합니다',
    offlineModeDetail: '오프라인에서 사용하면 데이터가 기기에 저장됩니다. 데이터 손실 없이 다른 기기로 전환하기 전에 로그인해야 합니다',
    logoutConfirmMessage: '정말 이 계정에서 로그아웃하시겠습니까?',
    notFoundEmail: '이 이메일로 계정을 찾을 수 없음',
    errorPassword: '잘못된 암호',
    emailInvalid: '이메일 형식이 잘못되었습니다',
    notFoundPurchase: '결제를 찾을 수 없습니다',
    purchaseLinkedWithOtherAcc: '이 결제는 이미 다른 계정에 연결되어 있습니다.',
    titleRequest: '이 이메일과 관련된 비밀번호 변경 요청을 받았습니다.',
    enterCodeEmail: '이메일로 전송된 인증 코드를 입력하세요'
  },
  statitical: {
    ...EN.statitical,
    chart: '차트',
    title: '통계',
    sale: '판매',
    expense: '비용',
    debtBook: '직불카드',
    revenue: '이익',
    saleToday: '오늘',
    sale7Days: '7일',
    sale30Days: '30일',
    returnOrderTitle: '반품 주문 통계',
    chart7Days: '최근 7일 차트',
    saleTitle: '판매 통계',
    revenueTitle: '이익 통계',
    orderTitle: '주문 통계',
    order: '주문',
    stock: '재고 통계',
    quantityOfInventory: '단위당 재고량',
    quantityOfInventoryByCategory: '카테고리별 인벤토리',
    inventoryCapital: '재고 자본',
    InventoryCapitalDetail: '(현재 입력 가격에 따라)',
    quantityOfInventoryProduct: '가장 많이 입고된 제품',
    inventoryCapitalDetail: '(현재 입력 가격 기준)',
    saleOfStaff: '직원 판매'
  },
  menu: {
    ...EN.menu,
    category: '카테고리',
    statitical: '통계',
    version: '버전',
    other: '기타',
    setting: '설정',
    shortcut: '바로가기',
    account: '계정',
    feedback: '피드백 및 제안',
    share: '이 앱을 친구에게 보내기',
    reportBug: '버그 보고서 데이터 보내기',
    reportLogBug: '오류 로그 보내기',
    policy: '사용 정책',
    term: '이용약관',
    editProfile: '정보 편집',
    orderReturn: '주문 반품',
    support: '지원'
  },
  settingForStaff: {
    ...EN.settingForStaff,
    branchHint: '이 항목은 카페 및 레스토랑 비즈니스 전용입니다',
    title: '매장 설정',
    staff: '직원',
    staffApp: '직원용 앱',
    branch: '지점 및 기본',
    emailExist: '이메일이 이미 존재합니다',
    cafe: '카페&레스토랑',
    passForStaff: '직원 비밀번호',
    passForStaffDetail: '영업 애플리케이션의 직원 로그인을 위한 특수 비밀번호입니다. 마스터 비밀번호와 동일하게 하지 마세요',
    mainBranch: '메인',
    addBranch: '베이스 추가',
    editBranch: '베이스 수정',
    addStaff: '직원 추가',
    editStaff: '직원 편집',
    table: '테이블',
    branchName: '기본 이름',
    branchTable: '테이블 수',
    staffs: '직원 목록',
    staffsDetail: '각 매장은 첫 번째 직원에게 1개월을 무료로 제공합니다',
    upgradeStaff: '갱신',
    appForStaffIntro: '직원 목록 앱, 직원들은 이 앱을 사용하여 주문을 생성할 수 있습니다. 사용하려면 직원 계정을 만들어야 합니다. 데이터가 기본 계정에 동기화됩니다.',
    shopType: '업종',
    grocery: '식료품, 슈퍼마켓',
    appForStaff: ['직원을 위한 판매자'],
    appForStaffDetail: ['레스토랑, 카페, 차, 식료품점, 소매점에 적합...'],
    shopTypeDetail: '직원용 영업 애플리케이션에서 올바른 인터페이스를 사용하려면 올바른 비즈니스 유형을 선택하세요.',
    showCustomer: '고객을 직원에게 보여주기',
    showCustomerDetail: '직원 앱에 고객 목록 표시',
    customerShowMode: ['모두 표시', '직원 손님만', '보이지 않음'],
    upgradeStaffContact: '',
    service: '서비스',
    serviceDetail: '가게, 카페, 밀크티, 레스토랑...',
    retail: '소매',
    retailDetail: '식료품, 슈퍼마켓...',
    showStatistial: '주간 판매량 표시',
    showStatistialDetail: '직원들이 지난 7일 동안의 매출을 볼 수 있도록 허용합니다.'
  },
  prefix: { title: '접두사', detail: '주문 코드, 제품 앞에 나타나는 문자열... 예: 주문 코드: HD123' },
  setting: {
    ...EN.setting,
    vote: '앱 평가!',
    timeFormat: '날짜 형식',
    about: '정보',
    title: '일반 설정',
    help: '도움이 필요하십니까?',
    currency: '통화',
    oddNumber: '홀수 단위 사용',
    oddNumberEx: '예: 1000.15VND, 0.5KG...',
    sync: '데이터',
    login: '로그인',
    logout: '로그아웃',
    notSignin: '로그인하지 않음',
    syncIntro: '데이터를 안전하게 유지하고 다른 기기로 전송할 수 있도록 백업을 위해 Google 계정에 로그인',
    syncNow: '지금 백업',
    lastSync: '마지막 백업 시간',
    restore: '데이터 복원',
    requireLogin: '이 기능을 수행하려면 Google 계정으로 로그인해야 합니다',
    syncNotFound: '백업을 찾을 수 없음',
    confirmSync: '서버의 데이터를 덮어씁니다. 데이터를 동기화하시겠습니까?',
    confirmRestore: '데이터를 복원하시겠습니까? 기존 데이터를 덮어쓰시겠습니까?',
    loginExpired: '로그인 세션이 만료되었습니다. 다시 로그인해주세요!',
    autoBackup: '자동으로 데이터 백업',
    googleAccountConnect: 'Google 계정',
    on: '켜기',
    off: '꺼짐',
    googleLogoutConfirm: '이 Google 계정을 종료하시겠습니까?',
    print: '프린터 연결',
    printDetail: '연결할 블루투스 프린터를 선택하고 제품 인보이스를 인쇄하세요.',
    connectPrinter: '프린터',
    invoice: '인보이스',
    invoiceHello: '감사합니다',
    surchargeText: '청구서의 할증료 단어 변경',
    invoiceSignature: '서명 표시',
    invoiceDebt: '미결제 잔액 표시',
    invoiceDebtInfo: '주문 세부정보, 청구서, 송장에 미결제 잔액 표시',
    debt: '부채',
    invoiceDebtDetail: '상세 차변',
    invoiceDebtDetailDetail: '차변 메모에 항목 세부 정보 표시',
    invoiceDiscount: '% 할인 표시',
    invoiceHelloDetail: '인보이스 아래 고객에 대한 감사 메모 편집',
    warningOutStock: '재고 없음 경고',
    warningOutStockDetail: '재고가 없으면 주문을 추가할 수 없습니다',
    warningOutStockMessage: '귀하의 제품은 품절되었습니다. 설정에서 이 경고를 더 입력하거나 비활성화하십시오',
    showRevenue: '이익 표시',
    orderStatus: '주문 상태 보기',
    orderStatusDetail: '"보류" 또는 "완료" 상태를 표시합니다. 사용하도록 설정하면 주문에 대한 영수증을 생성할 수 없습니다.',
    showHomeRevenue: '수익 보기',
    showHomeChart: '차트 보기',
    showHomeFinancial: '재정 보기',
    showHomeStatistial: '통계 보기',
    averageBuyPrice: '평균 수입 가격',
    averageBuyPriceDetail: '보다 정확한 수익 계산을 위해 각 수입 후 수입 가격이 자동으로 평균화됩니다.\n수식 = (현재 재고 총량 + 신규 재고 수량)/(총 수량)',
    showSurchargeShopPay: '판매자가 지불한 추가 요금 표시',
    showSurchargeShopPayDetail: '선택하지 않으면 판매자가 지불한 추가 요금이 청구서나 송장에 표시되지 않습니다.'
  },
  customer: {
    ...EN.customer,
    id: '게스트 ID',
    prefix: '고객 코드 접두사',
    title: '고객',
    create: '고객 추가',
    name: '고객 이름',
    address: '주소',
    phone: '전화번호',
    email: '이메일',
    add: '새 고객 추가',
    choice: '고객 선택',
    invalidPhoneOrAddress: '전화번호 또는 주소를 입력하세요',
    phoneExist: '이 전화번호는 이미 존재합니다',
    search: '이름 또는 전화번호로 필터링',
    free: '소매 고객',
    orderStatistics: '주문 통계',
    exportDebt: '차변 메모 만들기',
    addDebt: '부채 추가',
    yearOld: '세',
    countBirthDay: '%s일 남음',
    taxCode: '납세번호',
    citizenId: '식별코드',
    taxCodeHint: '납세번호로 기관 검색 가능',
    createScreen: {
      taxCodeNotFound: '세금 코드 정보를 찾을 수 없습니다',
      avatarLabel: '프로필 이미지',
      contactHint: '연락처에서 빠르게 정보를 채우거나 프로필 이미지를 추가할 수 있습니다',
      basicInfoTitle: '기본 정보'
    }
  },
  order: {
    lastPrice: '최근 가격',
    lastPriceAuto: '최근 판매가 자동 적용',
    lastPriceAutoDetail: '고객 주문에 소매가 대신 해당 고객의 최근 판매가를 자동 적용합니다',
    ...EN.order,
    editDeadline: '주문 수정 기한',
    editDeadlineDetail: '주문 생성일로부터 이 기간 내에 주문을 수정할 수 있습니다.',
    editDeadlineExpired: '주문 수정 기한이 지났습니다. "설정" -> "주문 설정"에서 주문 수정 가능 기간을 변경하세요.',
    id: '단일 코드',
    prefix: '주문 코드 접두사',
    title: '판매 주문',
    create: '주문 추가',
    edit: '주문 수정',
    detail: '주문 세부정보',
    exportInvoice: '지불 인보이스',
    add: '제품 추가',
    realPrice: '실제 가격',
    infoShop: '상점 정보',
    invalidCustomer: '고객 정보를 선택하세요',
    invalidProduct: '주문에 항목이 없습니다',
    confirmDelete: '이 %s를 삭제해야 합니다.?',
    search: '주문 코드, 고객 이름 또는 전화 번호로 필터링',
    discount: '할인',
    discount1: '할인',
    inStockNotEnough: '재고가 충분하지 않습니다. 더 많은 상품을 입력하거나 재고 수량을 업데이트하십시오.',
    createFailed: '주문 생성에 실패했습니다. 다시 시도하거나 개발자에게 피드백을 주세요.',
    surcharge: '추가 요금',
    surchargeDetail: '(선박, 세금...)',
    barcodeNotFound: '이 바코드는 아직 존재하지 않습니다. 주문에 추가하기 전에 상품을 입력하십시오',
    price: '가격',
    customPrice: '맞춤 가격',
    customPrice1: '%만큼 감소',
    orderMoneyUpdated: '판매 가격 변경으로 인해 주문 금액이 업데이트되었습니다.',
    totalProductMoney: '상품의 총 금액',
    totalMustPaidMoney: '지불할 총 금액',
    totalPaidMoney: '고객 지불',
    totalDebtMoney: '총 빚진 금액',
    paid: '지불됨',
    totalLiabilities: '총 부채',
    totalMustPaidMoneyForCustomer: '총액은 게스트에게 반환되어야 합니다.',
    totalPaidMoneyForCustomer: '재방문 손님',
    pointDiscount: '적립된 포인트 차감',
    money: '총 주문 금액',
    statusOffRequire: '주문 상태 끄기',
    statusOffRequireDetail:
      '주문 영수증을 생성합니다. 주문 상태를 꺼주셔야 주문 미결제 잔액에 혼란이 생길 ​​수 있습니다. 이 기능을 사용하기 위해 주문 상태를 비활성화하시겠습니까?',
    surchargeType2: '판매자 지불',
    surchargeType1: '구매자 지불',
    surchargeTypeHint:
      '- 구매자 지불: 주문 금액에 포함되며 수익에는 포함되지만 이익에는 포함되지 않습니다.\n- 판매자 지불: 주문 금액에 포함되지 않으며 매장 비용을 포함하는 해당 지불 바우처를 생성합니다.',
    emptyProduct: '아이템을 추가해주세요',
    draftOrderWarning: '참고: 이것은 임시 송장으로 아직 데이터베이스에 저장되지 않았습니다.'
  },
  product: {
    ...EN.product,
    multiStopSale: '일괄 판매 중지',
    multiSale: '상품 일괄 판매',
    stopSale: '판매 중지',
    sale: '판매',
    stopSaleList: '판매 중지 목록',
    saleList: '판매 중 목록',
    id: '상품 코드',
    prefix: '상품 코드 접두사',
    title: '상품',
    create: '상품 추가',
    add: '상품 추가',
    choice: '상품 선택',
    name: '상품 이름',
    priceType: '가격 선택',
    buyPrice: '가격 입력',
    sellPrice: '소매 가격',
    price: '제품 가격',
    sellPrice1: '프로모션 가격',
    sellPrice2: '도매 가격',
    recent: '최근에 추가된 제품',
    search: '코드별 필터링, 상품 이름',
    sold: '판매',
    inStock: '남은',
    outOfStock: '재고 없음',
    initStockDetail: '새 제품 생성 시 초기 재고 수량',
    barcode: '코드',
    exist: '상품이 이미 존재합니다. 이름 또는 바코드를 다시 확인하십시오',
    canNotDelete: '이 항목은 이미 주문에 있으므로 삭제할 수 없습니다. 먼저 주문을 삭제해주세요.',
    errorPrice: '잘못된 판매 가격 또는 입력 가격',
    changeSellPriceWarning: '참고: 가격 변경은 기존 주문에 영향을 미칩니다',
    changeSellPriceWarningDetail: '가격 변경은 기존 주문에 영향을 미치므로 이 항목이 포함된 주문을 업데이트해야 합니다. 정말 하시겠습니까?',
    hiddenNumProduct: '%s 제품 판매 중지',
    activeNumProduct: '%s 제품 판매',
    hiddenNumProductConfirm: '이 제품의 %s을(를) 판매 중지하시겠습니까?',
    activeNumProductConfirm: '%s 이 제품을 판매하시겠습니까?',
    deleteNumProduct: '%s 제품 삭제',
    deleteNumProductConfirm: '이 제품 %s을(를) 삭제하시겠습니까?',
    canNotDeleteProduct: '%s개의 상품이 이미 주문에 포함되어 있으므로 삭제할 수 없습니다.',
    barcodeExist: '이 바코드는 이미 다른 제품에 존재합니다.',
    syncAmount: '가져오기 주문과 인벤토리 동기화',
    syncAmountConfirm: '이 제품의 재고는 %s입니다. 다시 업데이트하시겠습니까?',
    type: '카테고리',
    type1: '카테고리(크기, 색상...)',
    typeHint: '클래스 이름',
    sku: 'Sku',
    skuExist: '이 SKU는 이미 존재합니다. 다른 값을 입력하세요!',
    limitUploadImage: '무료 버전은 제품당 1개의 이미지만 지원합니다. 더 많은 이미지를 추가하려면 업그레이드하세요!'
  },
  category: {
    ...EN.category,
    id: '카테고리 코드',
    prefix: '범주 코드 접두사',
    title: '카테고리',
    create: '카테고리 추가',
    name: '카테고리 이름',
    choice: '카테고리 선택',
    search: '코드, 카테고리 이름으로 필터링',
    categoryExist: '카테고리 이름이 이미 존재합니다',
    choiceProduct: '카탈로그에 추가할 제품 선택',
    tips: '팁',
    tip1: '짧고 이해하기 쉬운 카테고리 이름을 사용하십시오 (예: 음료, 패스트푸드 등).',
    tip2: '카테고리는 제품 분류 및 검색을 더 신속하게 하는 데 도움이 됩니다.',
    tip3: '생성 직후 이 카테고리에 제품을 할당할 수 있습니다.',
    itemsCountDesc: '현재 이 카테고리에 포함된 %s 개의 항목'
  },
  importOrder: {
    id: '단일 코드',
    prefix: '단일 항목 코드 접두사',
    title: '구매 주문',
    detail: '항목 세부정보',
    create: '항목 추가',
    edit: '입력 양식 수정',
    editProductPrice: '입력 가격 변경',
    editProductPriceWarning: '이 제품의 수입 가격을 %s로 변경하시겠습니까?'
  },
  provider: {
    ...EN.provider,
    id: '공급업체 ID',
    prefix: '공급업체 접두사',
    title: '제공자',
    create: '제공자 추가',
    name: '공급업체 이름',
    choice: '공급업체 선택',
    search: '코드, 이름, 공급업체 번호로 필터링',
    categoryExist: '제공자 이름이 이미 존재합니다',
    order: '주문',
    free: '알 수 없음',
    deleteWarning: '이 공급업체를 삭제하시겠습니까? 이 공급업체와 관련된 모든 주문은 알 수 없는 공급업체로 변경됩니다.'
  },
  googleDriver: {
    loginGoogle: '이 기능을 수행하려면 Google 계정에 로그인해야 합니다',
    backup: '백업',
    backupToDriver: '백업',
    backupSuccess: '백업 성공',
    backupError: '백업 실패',
    emptyBackup: '백업을 찾을 수 없음',
    loadingBackupFile: '백업 데이터 로드 중',
    backingUp: '백업',
    restore: '복원',
    restoreFromDriver: '복원',
    restoreSuccess: '데이터 복구 성공',
    restoring: '데이터 복구 중',
    resetData: '데이터 재설정',
    resetDataDetail: '처음부터 데이터 재설정',
    resetDataConfirm: '현재 데이터를 지우시겠습니까?',
    backupErrorCaseInvalidToken: 'Google 계정 세션이 만료되어 데이터를 백업할 수 없습니다. 로그인하고 다시 시도하십시오!',
    confirmReplaceOlderTitle: '덮어쓰기 확인',
    confirmReplaceOlderDetail: 'Google 드라이버에서 최신 데이터 버전을 찾았습니다. 현재 데이터를 백업하시겠습니까?',
    restoreChoose: '복원할 데이터 선택',
    backupRename: '기억에 남는 이름 편집',
    backupAt: '백업 시간'
  },
  rating: {
    title: '앱을 즐기세요',
    detail: '이 앱에 만족하셨다면 잠시 시간을 내어 리뷰를 작성해 주시면 최선을 다해 도와드리겠습니다.',
    rateNow: '지금 평가',
    rateLater: '나중에'
  },
  proVersion: {
    ...EN.proVersion,
    linked: '연결됨',
    paymentRecoveryHint: '이 계정에 대해 복구할 결제를 선택하세요!',
    name: '프리미엄 에디션',
    detail: '앱 프리미엄 버전 구매 시 변경 사항',
    removeAds: '프리미엄 버전 구매',
    removeAdsDetail: '한 번만 지불하면 됩니다. 다음 번에는 자동으로 복원됩니다.',
    paymentRecovery: '지불 복구',
    paymentRecoveryDetail: '프리미엄 버전 업그레이드에 대한 지불 복원',
    purchaseFailed: '결제 실패. 다시 시도해 주세요.',
    purchaseSuccess: '결제 성공, 감사합니다!',
    recoveryPaymentSuccess: '결제 복구 성공!',
    recoveryPaymentUnsuccess: '결제 복구에 실패했습니다. 다시 시도하십시오!',
    recoveryIfNeed: '이미 지불한 경우 지불을 복원하도록 선택하십시오.',
    cancelIfNeed: '언제든지 취소',
    expireDate: '만료일',
    expired: '오래됨',
    yourPackage: '프리미엄 버전을 사용 중입니다',
    packageFull: '무제한 평생 패키지',
    package1M: '1개월 패키지',
    package3M: '3개월 패키지',
    package6M: '6개월 패키지',
    package1Y: '1년 패키지',
    package5Y: '5년 패키지',
    package10Y: '10년 패키지',
    package1MDetail: '1개월 동안 프리미엄 버전을 사용하세요.\n기간이 만료되면 자동으로 갱신됩니다.',
    package3MDetail: '3개월 동안 프리미엄 버전을 사용하세요.\n기간이 만료되면 자동으로 갱신됩니다.',
    package6MDetail: '6개월 동안 프리미엄 버전을 사용하세요.\n패키지는 시간이 지남에 따라 누적되며 자동으로 갱신되지 않습니다..',
    package1YDetail: '프리미엄 버전을 1년 동안 사용하세요.\n패키지는 시간이 지남에 따라 누적되며 자동으로 갱신되지 않습니다..',
    package5YDetail: '프리미엄 버전을 5년 동안 사용하세요.\n패키지는 시간이 지남에 따라 누적되며 자동으로 갱신되지 않습니다.',
    package10YDetail: '프리미엄 버전을 10년 동안 사용하세요.\n자동 갱신이 없습니다',
    packageWarehouse1Y: '1년 연장된 창고',
    packageWarehouse1YDetail: '1년 동안 다른 확장 스토어를 추가하세요.\n자동으로 갱신하지 마세요',
    packageStaff1Y: '직원 1년',
    packageStaff1YDetail: '직원 계정을 1년 동안 갱신하세요.\n직접 갱신하지 마세요.',
    serviceFee: '서비스 수수료',
    packageAutoRenew: '패키지 자동 갱신',
    packageNonAutoRenew: '패키지가 자동 갱신되지 않음',
    recoverySumary: '이전에 지불한 경우. 광고가 아직 존재하거나 유료 버전의 기능을 사용하지 않았습니다. 아래에서 결제 복원을 선택하세요.',
    notFoundPurchase: '귀하의 결제 내역을 찾을 수 없습니다.',
    purchaseLinkedWithOtherAcc: '이 결제는 이미 다른 계정에 연결되어 있습니다.',
    recoverySumary1: '결제 복원에 성공했지만 여전히 제한이나 광고가 표시되는 경우 앱을 종료하고 다시 입력하세요.',
    purchaseProcessing: '결제가 진행 중이니 잠시만 기다려주세요. 결제에 성공했지만 여전히 업데이트되지 않으면 결제 복원을 클릭하십시오.',
    iapInLoading: '아직 준비되지 않았습니다. 잠시만 기다려주세요',
    yourPackageInfo: '귀하의 패키지',
    compare: '버전 비교'
  },
  upgrade: {
    hasNewVersion: '새 업데이트가 있습니다',
    changelog: '새 버전에서 변경',
    upgradeNow: '업데이트',
    later: '나중에',
    changeLogs: [
      '어두운 테마 선택 시 흐릿한 텍스트 수정',
      '일부 기기에서 주문이 저장되지 않는 문제 수정',
      '밝고 어두운 인터페이스에 맞게 광고 최적화',
      '개발자에게 버그 보고서를 보내는 기능 추가',
      '그리고 기타 사소한 버그 수정'
    ]
  },
  profile: {
    ...EN.profile,
    profileDetail: '매장 정보 및 연락처 정보를 업데이트합니다.',
    changeAvatar: '프로필 사진 변경',
    emailVerified: '인증된 이메일',
    title: '개인',
    nameShop: '가게 이름',
    placholderBank: '은행 계좌 입력',
    email: '이메일',
    address: '주소',
    phone: '전화번호',
    numberPhone: '표준',
    edit: '편집',
    save: '저장',
    bank: '은행 계좌 번호',
    placeholderBank: '은행 계좌 입력',
    placholderName: '상점 이름 입력',
    placholderEmail: '이메일 입력',
    placholderAdress: '주소 입력',
    placholderPhone: '전화번호 입력',
    avatarEmpty: '사진을 선택하세요',
    nameEmpty: '상점 이름은 비워둘 수 없습니다',
    emailEmpty: '이메일은 비워둘 수 없습니다',
    adressEmpty: '주소는 ​​비워둘 수 없습니다',
    phoneEmpty: '전화번호는 비워둘 수 없습니다',
    billInfo: '매장 정보',
    placholderBillInfo: '이 정보는 청구서에 표시됩니다(전화번호, 주소, 은행...)',
    freeAcc: '무료',
    proAcc: '프리미엄'
  },
  invoice: {
    ...EN.invoice,
    stt: '주문하다',
    titleImport: '소득 인보이스',
    titleReturn: '송장 반환',
    draft: '임시 인보이스',
    unit: '단위',
    title: '십억 지불',
    code: '코드:',
    nameClient: '클라이언트',
    order: '상품 코드',
    nameProduct: '상품 이름',
    number: 'SL',
    totalPrice: '돈으로',
    price: '총 금액',
    money: '단가',
    buyer: '쇼핑객',
    salesman: '판매자',
    writeFull: '(서명, 전체 이름)',
    day: '날짜',
    month: '월',
    year: '연도',
    save: '저장',
    thanks: '%s 제품을 사용해 주셔서 감사합니다. 최선을 다해!'
  },
  barcode: { title: '코드 스캔', message: '스캔할 컨테이너로 카메라 이동' },
  help: {
    removeAds: '광고를 제거할 수 있습니까?',
    removeAdsDetail: '프리미엄 버전 패키지를 구매하면 광고를 삭제할 수 있습니다. 패키지를 구매하지 않고도 애플리케이션의 대부분의 기능을 완벽하게 사용할 수 있습니다.',
    adsNotDisable: '프리미엄 버전을 구입했지만 광고가 계속 표시됨',
    adsNotDisableDetail:
      "- '왼쪽 상단 메뉴 아이콘' -> '프리미엄 버전' -> '결제 복원' 선택으로 이동합니다. 파란색 메시지가 나타나면 결제가 성공적으로 복원된 것입니다. 광고가 더 이상 표시되지 않습니다. \n- 빨간색 메시지가 나타나면 결제 복구에 실패한 것입니다. 당신은 당신의 지불을 다시 확인하시기 바랍니다. 또는 iTunes Store 계정에 동일한 결제 계정이 있습니다. \n- 성공적으로 지불했지만 지불 복구를 활성화할 수 없는 경우. 지원을 위해 이메일 xgitdev@gmail.com을 통해 개발자에게 문의하세요",
    recoveryData: '내 데이터를 다른 컴퓨터로 백업하거나 전송할 수 있습니까?',
    recoveryDataeDetail:
      '계정을 등록한 다음 메뉴를 열어 현재 데이터를 동기화하도록 선택하면 더 이상 데이터가 손실되지 않습니다. 기기에 데이터가 없는 경우 동기화 단계를 건너뛸 수 있습니다.\n다른 기기로 이동하려면 현재 계정에 로그인해야 정상적으로 사용할 수 있습니다.',
    recoveryDataAuto: '데이터를 자동으로 백업할 수 있습니까?',
    recoveryDataeAutoDetail: '이 기능은 설정에서 사용할 수 있습니다. 단, 이 기능은 프리미엄 버전에서만 사용할 수 있습니다.'
  },
  importFromCSV: {
    textHint: 'CSV 파일에서 텍스트 데이터 가져오기',
    title: 'csv 파일에서 빠른 가져오기',
    choiceFile: '파일 선택',
    intro: '대량 주문을 생성하려면 아래 내용을 입력하십시오. 샘플 및 자습서는에서 찾을 수 있습니다',
    enterText: '텍스트 입력',
    newCustomer: '신규 고객',
    productInvalid: '잘못된 상품',
    productInvalidMessage: '잘못된 상품 코드입니다. 빨간색으로 강조 표시된 항목의 코드를 다시 확인하십시오',
    check: '확인',
    save: '주문 저장',
    emptyDataMessage: '주문을 찾을 수 없음',
    complete: '입력 완료',
    gotIt: '알았다',
    here: '여기',
    syntaxIntro1: '여기에서 샘플 CSV 파일을 볼 수 있습니다.',
    syntaxIntro2: '그런 다음 CSV 파일을 텍스트로 연 다음 CSV 파일의 내용을 복사하여 입력 상자의 입력 상자에 붙여넣어야 합니다.',
    syntax: '구문',
    examp: '예시',
    syntaxTut: '아래 구문에 따라 데이터 형식을 지정하십시오. 주문은 캐리지 리턴으로 구분됩니다.',
    syntaxDetail:
      '전화번호|고객명|주소,추가요금,상품코드|수량|할인\n전화번호|고객명|주소,추가요금,상품코드|수량|할인,상품코드|수량|할인\n전화번호|고객명| 주소,추가 요금,상품 코드|수량|할인,상품 코드|수량|할인,상품 코드|수량|할인,상품 코드|수량|할인',
    syntaxExamp: '0123456789|NGUYEN VAN A|Ha Noi,10,SP1|5|0\n0123456789|NGUYEN VAN A|하노이,10,SP1|5|0,SP2|4|0\n0123456789|NGUYEN VAN A|하노이 10,SP1|5|0,SP2|4|0,SP3|4|0'
  },
  bill: {
    ...EN.bill,
    name: '청구서',
    title: '지불 인보이스',
    product: '항목',
    day: '판매일',
    amount: 'SL',
    money: '티머니',
    totalMoney: '총 금액',
    thanks: '고마워요!',
    createBy: '앱으로 전문적으로 판매',
    unit: '단위',
    discount2: '할인%',
    discount1: '할인 금액',
    customImage: '사용자 정의 이미지',
    customText: '사용자 정의 텍스트',
    moneyText: '금액 한글 표기'
  },
  printer: {
    ...EN.printer,
    connected: '프린터가 성공적으로 연결되었습니다!',
    name: '프린터',
    title: '프린터 연결',
    find: '블루투스 프린터를 찾고 있습니다. 잠시만 기다려주세요!',
    empty: '프린터를 찾을 수 없음',
    unknow: '알 수 없음',
    pressToConnect: '프린터 장치를 올바르게 연결하려면 탭하세요',
    notConnect: '설정에서 프린터를 연결하십시오.',
    trial: '남은 시도가 %s 있습니다',
    trialExpired: '모든 평가판을 사용했습니다. 이 기능을 사용하려면 프리미엄 버전으로 업그레이드하십시오',
    printError: '프린터가 준비되지 않았습니다. 다시 시도해 주세요!',
    devicesTested: '개발 팀에서 테스트한 장치: xPrinter 58iiH, GOOJPRT PT-210'
  },
  importFromExcel: {
    ...EN.importFromExcel,
    textHint: '여기에 Excel 파일의 텍스트 데이터를 입력하세요',
    title: 'Excel 파일에서 빠른 가져오기',
    choiceFile: '파일 선택',
    intro: '대량 주문을 생성하려면 아래 내용을 입력하십시오. 샘플 및 자습서는 에서 찾을 수 있습니다',
    introProduct: '빠르게 상품을 가져오려면 엑셀 파일을 선택하세요. 내보낸 파일은 파일 형식이 동일하지 않으니 상품 목록에서 선택하지 마세요. 에서 샘플 및 자습서를 볼 수 있습니다i',
    introProduct1: '더 쉬운 작업을 위해 웹 버전을 사용하는 것이 좋습니다. 시스템이 인식하기 전에 입력해야 하는 단위 및 카테고리',
    enterText: '텍스트 입력',
    newCustomer: '신규 고객',
    productInvalid: '잘못된 상품',
    productInvalidMessage: '잘못된 상품 코드입니다. 빨간색으로 강조 표시된 항목의 코드를 다시 확인하십시오',
    check: '확인',
    save: '%s 제품 저장',
    emptyDataMessage: '주문을 찾을 수 없음',
    complete: '입력 완료',
    gotIt: '알았다',
    here: '여기',
    syntaxIntro1:
      '한 번에 500개 미만의 레코드를 가져와야 합니다. 여러 파일로 나누어 가져올 수 있습니다. 상품의 이름, 코드 또는 SKU는 동일할 수 없습니다. 변경할 필요가 없는 열은 삭제해야 합니다. 여기에서 샘플 파일을 참조할 수 있습니다.',
    syntaxIntro2: '그런 다음 Excel 파일을 텍스트로 연 다음 Excel 파일의 내용을 복사하여 입력 상자의 입력 상자에 붙여넣어야 합니다.',
    found: '%s제품을 찾았습니다.',
    demo: '샘플 파일'
  },
  unit: {
    ...EN.unit,
    id: '단위 코드',
    title: '단위',
    choice: '단위 선택',
    create: '새 단위 만들기',
    name: '단위 이름',
    search: '코드, 유닛명으로 필터링',
    exist: '유닛명이 이미 존재합니다',
    tips: '팁',
    tip1: '표준 측정 단위를 사용하십시오(예: 개, 팩, 박스, 케이스...).',
    tip2: '단위는 더 정확한 재고 관리 및 판매에 도움이 됩니다.',
    tip3: '제품 상세 정보에서 직접 단위 변환을 설정할 수 있습니다.'
  },
  timeFilter: {
    today: '오늘',
    yesterday: '어제',
    last7Days: '지난 7일',
    last30Days: '지난 30일',
    custom: '사용자 정의',
    thisMonth: '이번 달',
    lastMonth: '지난 달',
    choiceStartDate: '시작',
    choiceMonth: '월 선택',
    choiceEndDate: '종료'
  },
  autoRestoreDb: {
    title: '데이터 복구',
    message: '계정 데이터의 최신 버전을 감지했습니다. 최신 데이터와 동기화하시겠습니까?'
  },
  support: {
    title: '라이브 지원',
    emailSupportDetail: '당신은 저희에게 연락하고 싶습니다. 다음 연락 방법 중 하나를 선택하십시오.',
    emailSupport: '이메일 개발자',
    zaloSupportDetail: '응용 프로그램 오류 또는 사용 방법에 대한 FAQ와 같은 긴급 지원이 필요한 경우. Zalo를 통해 지원을 선택하십시오.',
    zaloSupport: 'zalo 그룹을 통한 지원'
  },
  customerDebt: {
    ...EN.customerDebt,
    title: '총 부채',
    total: '총 미결제',
    customerDebtStatistial: '고객별 부채',
    beginningBalance: '시작 잔액',
    beginningDebts: '시작 차변',
    closingBalance: '마감 잔액',
    closingDebts: '마감 부채',
    simple: '짧은 버전'
  },
  staffUpgrade: {
    upgradeForStaff: '직원을 갱신하고 있습니다. 이전에 결제했지만 업데이트되지 않은 경우. 결제 복원을 선택하세요.',
    staff1m: '1개월 연장',
    staff6m: '6개월 연장',
    staff1y: '1년 연장'
  },
  returnOrder: {
    edit: '반품 주문 편집',
    create: '반품 주문 추가'
  },
  maintenance: {
    ...EN.maintenance,
    title: '유지 관리',
    message: '저희 서버가 %s분 동안 점검 중입니다. 나중에 다시 오시기 바랍니다.',
    timeout: '죄송합니다! 오류가 발생했습니다. 몇 분 후에 다시 시도해 주세요. 여전히 작동하지 않으면 지원팀에 문의해 주세요!!!',
    messageTimeout: '저희 서버가 좀 바쁩니다! 다시 다운로드를 시도하십시오! 그래도 안되면 5분 정도 쉬었다가 다시 시도해보세요!. 매우 감사합니다!',
    networkError: '네트워크 오류',
    networkErrorDetail: '데이터를 로드하지 못했습니다. 다시 시도해 주세요. 오류가 여러 번 반복되는 경우. 5분 정도 기다린 후 다시 시도하십시오!'
  },
  financialBook: {
    ...EN.financialBook,
    debt: '부채 메모',
    createDebt: '부채 생성',
    title: '재무부',
    receipts: '영수증',
    paymentVoucher: '지불 문서',
    moneyFromCustomer: '고객 컬렉션',
    moneyForProvider: '공급자에게 지불',
    moneyForReturn: '환불 환불',
    moneyFromReturn: '입고 반품 수령액',
    idAutoGen: '자동 쿠폰 코드',
    cash: '현금',
    bank: '은행',
    totalFund: '총자금',
    submitter: '작성자',
    typeCharge1: '수신기 유형',
    typeCharge2: '속 유형',
    receipt: '영수증 만들기',
    vouchers: '바우처 만들기',
    fullName: '이름',
    submitters: '제출자',
    money: '금액',
    textEmptyFinancial: '아직 영수증/지불이 없습니다. ',
    accountBank: '수취 계좌',
    nameBank: '은행 계좌',
    accountNumber: '계좌 번호',
    accountHolder: '계좌 명의인',
    receiptForOrder: '주문 영수증',
    paymentForOrder: '주문서',
    receiptFromCustomer: '고객으로부터 받은 영수증',
    receiptAutoGenFor: '주문에 대해 자동으로 생성된 영수증',
    paymentForProvider: '공급자를 위한 결제',
    paymentForCustomer: '고객의 결제 전표',
    paymentVoucherAutoGenFor: '주문 자동 생성 수표',
    autoFinancialCanNotEdit: '이 티켓은 자동으로 생성됩니다. 관련 주문을 수정하십시오 ',
    createType: '새로 만들기',
    deleteType: '카테고리 삭제',
    deleteTypeWarning: '범주 %s을(를) 삭제하시겠습니까?',
    exportBill: '투표 내보내기',
    deleteBill: '투표 삭제',
    deleteBillWarning: '이 티켓을 삭제하시겠습니까?',
    investment: '펀드 투입',
    investmentDetail: '투입자금은 최초 판매시점부터 기간초까지 계산된 총 잔액(수익-지출)을 말합니다. \n예: 이번 달을 선택한 시간이면 해당 월의 1일 이전 잔액이 투자 자금이 됩니다.',
    totalRevenue: '총 수익',
    totalSpending: '총 지출',
    totalBlance: '총 잔액'
  },
  sortType: {
    ...EN.sortType,
    newest: '최신',
    oldest: '가장 오래된',
    alphabet: '가나다순'
  },
  guide: {
    revenue: '총 수익',
    expenditure: '총 지출',
    title: '초보자를 위한 팁',
    expenseReport: '비용 보고서 보기',
    product: '시작하려면 제공할 제품 또는 서비스를 추가하세요. ',
    customer: '새 고객을 추가하는 것은 고객 정보를 초기화하고 향후 거래 프로세스에서 부채를 관리하는 기본 작업입니다.',
    provider: '공급업체와 관련된 모든 데이터를 관리할 수 있도록 공급업체를 만들어야 합니다. 연락처 정보, 채무, 수입 내역...',
    order: '주문은 품절로 기록되고 주문이 생성되면 고객에게 배송됩니다 ... 주문 필터링을 용이하게하기 위해 주문 메모와 태그를 주문에 추가하십시오. ',
    category: 'Category 는 항목 카테고리의 컬렉션을 관리하는 곳입니다. ',
    complete: '기본을 마스터했습니다. aSeler가 여러분을 위해 설계한 많은 기능들이 있습니다. '
  },
  productHistoryLog: {
    title: '리포지토리 기록',
    sale: '수출',
    import: '저장소 가져오기',
    update: '체크아웃',
    return: '재고 환불',
    delete: '취소 환불',
    amount: '거래 금액',
    result: '거래 후 금액',
    importReturn: '반품'
  },
  orderType: {
    ...EN.orderType,
    sale: '판매',
    return: '반환',
    import: '가져오기',
    receipt: '영수증',
    payment: '결제',
    debt: '부채',
    importReturn: '입고 반품'
  },
  newCodepush: {
    title: '최신 버전을 사용할 수 있습니다.',
    des: '방금 출시된 최신 버전이 있습니다. 지금 업데이트하시겠습니까',
    cancel: '나중에',
    ok: '업데이트'
  },
  printSetting: {
    ...EN.printSetting,
    title: '인보이스 인쇄 설정',
    type: '프린터 유형',
    connection: '프린터',
    asellerLogo: '판매자 로고 표시',
    bluetooth: '블루투스 프린터',
    wifi: '와이파이 프린터',
    deviceIp: '프린터 IP 주소',
    deviceIpEx: '예: 192.168.1.100',
    size: '인쇄 크기',
    invalidIP: '유효한 IP를 입력하세요!',
    canNotConnectIP: '이 IP에 연결할 수 없습니다. 프린터의 IP를 다시 확인하십시오!',
    notReady: '프린터가 준비되지 않았습니다. 먼저 프린터 설정으로 이동하세요!',
    support:
      'WIFI, Bluetooth, USB에 연결된 ESC/POS 열전사 프린터를 지원합니다.\n참고: 라벨 프린터는 지원되지 않습니다. \n한 번에 1개의 장치만 프린터에 연결할 수 있습니다.\n테스트된 프린터: xPrinter 58iiH(블루투스), GOOJPRT PT-210(블루투스), xPrinter T80L(WIFI)',
    qrBank: '인보이스 끝에 맞춤 사진 추가',
    qrBankDetail: '송장 하단에 표시되는 은행 QR 코드를 추가할 수 있습니다.'
  },
  homeOfflineWarning: {
    message: '오프라인을 사용 중입니다. 더 많은 기능을 사용하려면 온라인으로 전환하세요. 그리고 데이터가 손실되지 않습니다.',
    helpButton: '온라인으로 전환하는 방법'
  },
  statStock: {
    typeChoice: '인벤토리 통계 기준',
    inventoryCapital: '재고'
  },
  customerGroup: {
    title: '고객 그룹',
    search: '이름 또는 코드로 필터링',
    id: '그룹 코드',
    prefix: '그룹 코드 접두사',
    create: '그룹 추가',
    choice: '손님 그룹 선택',
    choiceCustomers: '고객을 그룹에 추가',
    name: '그룹 이름',
    tablePrice: '가격 목록',
    priceHint: '고객이 이 그룹에 있으면 가격 목록이 판매 주문에 자동으로 적용됩니다.',
    editNotice: '편집 모드 - 완료하려면 상단의 "저장"을 누르세요',
    removeCustomer: '이 고객을 그룹에서 삭제하시겠습니까?'
  },
  settings: {
    title: '설정',
    garena: '일반 설정',
    home: '홈 설정',
    order: '주문 설정',
    invoice: '송장 설정',
    product: '제품 설정',
    debt: '잔액 설정',
    point: '포인트 설정',
    salesGroup: '판매 및 송장',
    systemGroup: '시스템 및 인터페이스',
    businessGroup: '고객 및 비즈니스',
    accountGroup: '계정 및 보안',
    displayAndTheme: '화면 및 테마',
    currencyAndTime: '통화 및 시간',
    security: '보안',
    stockSettings: '재고 설정',
    homeWidgets: '홈 위젯',
    pointSettings: '포인트 설정',
    resetPointTitle: '설정 초기화',
    systemPermissions: '시스템 권한',
    invoiceSettings: '송장 설정',
    debtSettings: '미수금 설정',
    orderSettings: '주문 설정',
    descOrder: '상태, 반올림, 추가 요금, 시간제 서비스',
    descProduct: '재고, 원가, 초기 재고',
    descInvoice: '송장 템플릿, VietQR, 은행 계좌',
    descPrinter: '용지 크기, 블루투스, Wifi, USB 프린터',
    descShift: '교대 시작, 종료, 현금 인계',
    descGeneral: '테마, 언어, 글꼴 크기, 통화, PIN',
    descHome: '매출 표시, 차트, 재무 보고서',
    descPermission: '카메라, 사진 보관함, 블루투스, 알림',
    descPoint: '회원 적립 포인트, 전환율',
    descShop: '지점 관리, 직원 관리, 판매 웹사이트',
    descEInvoice: '전자세금계산서 설정 및 발행',
    descPassword: '계정 비밀번호 변경',
    descDeleteAcc: '계정 및 매장 데이터 영구 삭제',
    shopManager: '매장 관리자',
    staffRole: '직원',
    granted: '허용됨',
    grantPermission: '권한 부여',
    noVietQRConfig: 'VietQR 은행 계좌가 설정되지 않음',
    uploadQRImage: 'QR 코드 이미지 업로드',
    s2aHkdGroup: 'S2A-HKD 업종 그룹',
    s2aHkdGroupDetail: 'S2A-HKD 원장 출력 시 기본 업종',
    s2aHkdTaxRate: 'S2A-HKD 기본 부가세율 (%)',
    s2aHkdTaxRateDetail: '상품/주문에 명확한 VAT가 없을 때 사용',
    s2aHkdTncnRate: 'S2A-HKD 개인소득세율 (%)',
    s2aHkdTncnRateDetail: 'S2A-HKD 출력 시 개인소득세율(%)',
    manualEnterIPDetail: '프린터가 검색되지 않으면 IP를 직접 입력하세요',
    previewPrint: '인쇄 미리보기'
  },
  customerPoint: {
    ...EN.customerPoint,
    point: '누적 포인트',
    pointShort: '포인트',
    description: '고객 보상 관리',
    history: '누적 기록',
    use: '포인트 적립 활성화',
    mtpRate: '포인트 전환율',
    mtpRateDetail: '주문 값 %s%s = 누적 포인트 1개',
    ptmRate: '현금 전환율',
    ptmRateDetail: '1 포인트 = %s%s',
    allowPayment: '포인트 결제 허용',
    allowForSaleProduct: '할인 제품 구매시 포인트 적립',
    allowForOrderPayByPoint: '보상 포인트로 결제 주문 누적',
    change: '적립된 포인트 업데이트 중',
    invalidPoint: '잘못된 포인트',
    invalidNote: '메모를 입력해주세요',
    usePoint: '포인트 사용',
    showPointOnInvoice: '송장에 포인트 표시',
    reset: '적립된 포인트 모두 삭제',
    resetWarning: '고객이 현재 적립한 포인트를 모두 삭제하시겠습니까?'
  },
  shift: {
    ...EN.shift,
    title: '교대근무 종료',
    end: '교대 종료',
    totalOrder: '총 청구서',
    totalMoney: '총 교대근무',
    paid: '전체 핸드오버',
    staff: '직원',
    cash: '현금',
    bank: '전송',
    shiftOrder: '교대 주문',
    open: '교대 시작',
    closed: '교대 종료',
    opening: '교대 시작',
    openingAmount: '시작 현금',
    handoverType: '인계 방식',
    actualHandoverAmount: '실제 인계 금액',
    differenceAmount: '차액',
    totalExpectedHandoverAmount: '인계 필요 총액',
    orderUnit: '건',
    currencyUnit: '₫',
    endReport: '교대 마감 보고서',
    ended: '교대 마감됨',
    shift: '판매 교대',
    actualHandoverDesc: '직원이 실제 인계한 금액',
    updatingOnClose: '교대 마감 시 업데이트됩니다',
    matchedDiffDesc: '금액이 완전히 일치합니다',
    checkDiffDesc: '차이 발생 사유를 대조 및 확인하세요',
    diffCalculatedOnClose: '교대 인수인계 후 계산됩니다',
    searchOrdersPlaceholder: '주문번호, 고객, 전화번호로 검색...',
    emptyOrder: '현재 교대에는 발생한 주문이 없습니다.',
    handoverTypeDetail: '직원이 교대 근무를 마감하고 인계할 때 수령한 결제 수단',
    requireOpening: '교대 시작 필수',
    requireOpeningDetail: '교대가 시작된 경우에만 판매 주문을 만들 수 있습니다',
    settings: '교대 설정',
    settingsDetail: '교대 시작 및 인계를 설정합니다',
    openError: '교대를 시작할 수 없습니다',
    expectedHandoverAmount: '예상 인계 금액',
    totalMoneyInShift: '교대 근무 내 총액',
    needHandover: '인계 필요',
    endConfirm: '이 교대를 마감하시겠습니까?'
  },
  warehouse: {
    ...EN.warehouse,
    title: '창고',
    renew: '창고 갱신',
    choice: '창고 선택',
    stat: '재고현황',
    createNew: '티켓 생성',
    create: '인벤토리 생성',
    checkId: '인벤토리 코드',
    name: '창고 이름',
    check: '인벤토리 확인',
    createCheck: '인벤토리 확인 생성',
    history: '재고 내역',
    noHistory: '아직 인벤토리 내역이 없습니다. 새 티켓을 생성해주세요',
    noTransferHistory: '아직 이체 내역이 없습니다!',
    totalProduct: '총 제품',
    tmpCheck: '임시 티켓',
    cancelCheckConfirm: '이 확인을 취소하시겠습니까?',
    cancelTransferConfirm: '이 전송을 취소하시겠습니까?',
    default: '주 저장소',
    address: '저장소 주소',
    manager: '재고 관리',
    detail: '인벤토리 정보',
    transfer: '재고 이전',
    transferCard: '창고 이전 전표',
    checkCard: '재고 확인 전표',
    emptyTargetWarehouse: '대상 창고가 유효하지 않습니다. 대상 창고를 선택하세요!',
    limit: '참고: 각 계정에는 두 번째 창고에 대해 1개월 무료가 제공됩니다. 만료 후 사용하려면 갱신해야 합니다.',
    expired: '이 저장소는 만료되었습니다. 갱신해서 사용하세요!',
    package1Y: '1년 연장',
    emptyTransferHint: '"바코드" 또는 "상품"을 탭하여 이동 시작',
    emptyCheckHint: '"바코드" 또는 "상품"을 탭하여 재고 조사 시작',
    noProduct: '선택된 상품이 없습니다'
  },
  homeScreen: {
    ...EN.homeScreen,
    support: '지원이 필요하세요?',
    supportDetail: '질문에 답변하거나 문제를 보고해 주세요',
    changelog: '변경 로그',
    changelogDetail: '애플리케이션의 최신 기능인 변경 사항에 대한 변경 로그를 추적합니다. ',
    autoUpdate: '자동 업데이트',
    autoUpdateDetail: '새 업데이트가 있으면 시스템에 업데이트 요청이 표시됩니다. 이 기능을 끄면 버그 수정이나 새로운 기능을 놓칠 수 있습니다.',
    autoUpdateNoAvailable: '최신 버전을 사용하고 있습니다!',
    autoUpdateFailed: '업데이트 중에 오류가 발생했습니다. 나중에 다시 시도 해주십시오!',
    vipExpired: '귀하의 프리미엄 패키지가 만료되었습니다. 전체 기능을 이용하려면 갱신하세요!'
  },
  productSetting: {
    sort: '목록 정렬',
    sortDetail: '제품 정렬 기준',
    sortTypes: ['최신 항목부터', '알파벳순으로 이름 지정', '오래된 항목부터']
  },
  intro: {
    shift: '이 기능은 서비스 비즈니스 유형을 위한 것입니다. 직원들은 직원 앱을 사용하여 교대근무를 마감합니다. 직원 교대 마감 정보가 여기에 표시됩니다.',
    customerGroup:
      '고객 개체를 그룹화하는 기능입니다. 예를 들어 레벨 1 에이전트, 레벨 2 에이전트... 각 고객 그룹에 대한 상품 가격표를 생성할 수 있습니다. 주문을 생성할 때 고객이 가격표가 있는 그룹에 속해 있으면 해당 가격표가 자동으로 적용됩니다!',
    emptyProduct: '아직 상품이 없습니다. 계속하려면 상품을 더 추가하세요!',
    draftOrder:
      '이 기능은 동시에 여러 주문을 생성하려는 경우에 적합합니다. 그리고 네트워크 연결 없이도 판매 주문을 생성할 수 있습니다. 이는 연결에 문제가 있거나 서버가 유지 관리 중인 경우에 매우 유용합니다.'
  },
  printBarcodede: {
    print: '바코드 인쇄'
  },
  draftOrder: {
    ...EN.draftOrder,
    title: '송장 초안',
    manager: '초안 송장 관리',
    cancel: '초안 취소',
    cancelConfirm: '이 송장 초안을 취소하시겠습니까?',
    noConnectionWarning: '기기가 네트워크에 연결되어 있지 않습니다. 인터넷 연결 없이 초안 송장을 생성하려면 아래의 "초안 송장 관리"로 이동하세요.',
    emergencyModeWarning: '현재 비상 모드입니다. 주문은 기기에 임시로만 저장되며 서버에 기록되지 않았습니다.',
    exportInvoice: '임시 인보이스'
  },
  deleteAcc: {
    title: '계정 삭제',
    warning: '이 계정을 삭제하시겠습니까? 삭제한 후에는 데이터를 복원할 수 없습니다. 이메일로 전송된 확인 코드가 필요합니다!',
    confirmCode: '확인 코드',
    confirmCodeShort: '확인 코드가 너무 짧습니다.'
  },
  appError: {
    eyebrow: '문제가 발생했습니다',
    title: '앱을 다시 시작해야 합니다',
    detail: '예기치 않은 오류가 발생했습니다. 계속하려면 앱을 다시 시작하세요.',
    reload: '앱 다시 시작'
  },
  introData: [
    {
      title: 'aSeller POS에 오신 것을 환영합니다!',
      detail: '언제 어디서나 매장을 쉽게 관리할 수 있는 스마트한 판매 관리 솔루션.'
    },
    {
      title: '주문, 상품, 고객을 손쉽게 관리',
      detail: '매출, 지출, 채무, 재고 입출고 및 영수증 발행을 간편하게 처리하세요.'
    },
    {
      title: '데이터는 클라우드에 안전하게 저장되며, 여러 기기에서 동기화 가능.',
      detail: '📶 언제든지 접근 가능하며, 기기를 변경해도 데이터 유실 걱정 없음!'
    },
    {
      title: '판매 관리는 이제 더 쉬워졌습니다!',
      detail: '매장을 설정하고, 상품을 추가하고, aSeller POS로 지금 바로 판매를 시작하세요.'
    }
  ],
  shipping: {
    ...EN.shipping,
    createHint: '수동으로 배송을 생성하거나, 설정된 경우 배송사 API를 호출할 수 있습니다.',
    createMode: '생성 모드',
    createModeHintManual: '내부 배송을 생성하고 운송장 번호를 수동 입력할 수 있습니다.',
    createModeHintProvider: '배송사 API를 호출해 배송을 생성하고 운송장 번호를 자동으로 받습니다.',
    providerModeUnavailable: '이 배송사는 API 생성 설정이 부족하여 수동 모드가 사용됩니다.',
    providerCodeAutoGenerated: '배송 생성이 성공하면 운송장 번호는 배송사에서 반환됩니다.',
    providerCreateFailed: '배송사에서 배송 생성에 실패하여 내부 배송은 저장되지 않았습니다.',
    irregularTransitionConfirm: '선택한 상태가 일반적인 처리 흐름에 있지 않습니다. 업데이트하시겠습니까？',
    invalidProviderConfigJson: 'Credentials 또는 settings JSON 이 올바르지 않습니다',
    providerSettings: 'Provider Settings',
    providerSettingsJson: 'Provider Settings (JSON)',
    providerConfigGuide: 'Suggested fields by provider',
    createModeList: {
      manual: '수동 생성',
      provider: '배송사로 생성'
    }
  }
};
